export class LoadingTime {
    id: number;
    time: number;
    route: string;
    userAgent: string;
    account: string;
    dateTime: Date;
}